import { useEffect, useState } from 'react';

/**
 * Tracks the `prefers-reduced-motion` media query.
 *
 * Every animation in the site gates on this: when it returns `true`,
 * components render their final state immediately rather than animating.
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduced(mql.matches);

    const handle = (event: MediaQueryListEvent): void => setReduced(event.matches);
    mql.addEventListener('change', handle);
    return () => mql.removeEventListener('change', handle);
  }, []);

  return reduced;
}
